module.exports = __webpack_public_path__ + "static/media/moto_5.bdf4d98f.png";